import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions, REDUCER_KEY } from './reducer';
import { getEnvironmentSettings } from 'services/environment';

export function useCampaignSummary() {
    const dispatch = useDispatch();
    const state = useSelector(state => state[REDUCER_KEY]);
    const boundActions = bindActionCreators(actions, dispatch);

    const { ownOrganization = {}, ftaLocationLists = [], campaign = {} } = state;

    const REVENUE_MODEL_OPTIONS = [
        { label: 'CPM / CPC', value: 'cpmcpc' },
        { label: 'CPM', value: 'cpm' },
        { label: 'Agency margin', value: 'agencyMargin' },
        { label: 'Disabled', value: 'disabled' },
    ];

    const BUDGET_ALLOCATION_OPTIONS = [
        { label: 'Auto', value: 'auto' },
        { label: 'Manual', value: 'manual' },
    ];

    const RESTRICTED_CATEGORY_OPTIONS = [{ label: 'Cannabis', value: 'cannabis' }];

    const getShowFta = () =>
        (campaign.fta_version === 2 && ownOrganization.ftaEnabled) ||
        campaign.isUsingFtaFullyManagedFields;

    const getShowFtaFullyManagedFields = () =>
        campaign.isUsingFtaFullyManagedFields && campaign.fta_enabled;

    const getLocationListsMapping = () => {
        const locationListsMapping = {};

        _.each(ftaLocationLists, option => {
            locationListsMapping[option.id] = option;
        });

        return locationListsMapping;
    };

    const getRevenueModelMapping = () => {
        const revenueModelMapping = {};

        _.each(REVENUE_MODEL_OPTIONS, option => {
            revenueModelMapping[option.value] = option;
        });

        return revenueModelMapping;
    };

    const getBudgetAllocationMapping = () => {
        const budgetAllocationMapping = {};

        _.each(BUDGET_ALLOCATION_OPTIONS, option => {
            budgetAllocationMapping[option.value] = option;
        });

        return budgetAllocationMapping;
    };

    const getRestrictedCategoryMapping = () => {
        const restrictedCategoryMapping = {};

        _.each(RESTRICTED_CATEGORY_OPTIONS, option => {
            restrictedCategoryMapping[option.value] = option;
        });

        return restrictedCategoryMapping;
    };

    const locationListsMapping = getLocationListsMapping();
    const revenueModelMapping = getRevenueModelMapping();
    const budgetAllocationMapping = getBudgetAllocationMapping();
    const showFta = getShowFta();
    const showFtaFullyManagedFields = getShowFtaFullyManagedFields();
    const restrictedCategoryMapping = getRestrictedCategoryMapping();

    const clientGrouping = _.groupBy(campaign.clients, 'type');

    const envSettings = getEnvironmentSettings();

    const showBudgetOptimizationField = envSettings.canUseAutoBudgetAllocation();

    return {
        ...state,
        ...boundActions,
        locationListsMapping,
        revenueModelMapping,
        budgetAllocationMapping,
        showFta,
        showFtaFullyManagedFields,
        clientGrouping,
        showBudgetOptimizationField,
        restrictedCategoryMapping,
    };
}
